// Style guide components
import Submenu from '@innoq/innoq-styleguide/dist/js/components/submenu.js'
import MenuToggle from '@innoq/innoq-styleguide/dist/js/components/menu-toggle.js'
import CheckToToggle from '@innoq/innoq-styleguide/dist/js/components/check-to-toggle'
import MultiToggler from '@innoq/innoq-styleguide/dist/js/components/multi-toggler'
import WallOfConsent from '@innoq/innoq-styleguide/dist/js/components/wall-of-consent'
import AutoSubmitForm from './frontend/components/auto-submit-form'
import TouchDetection from '@innoq/innoq-styleguide/dist/js/components/touch-detection'
import AudioPlayer from '@innoq/innoq-styleguide/dist/js/components/audio-player'
import QuoteCarousel from '@innoq/innoq-styleguide/dist/js/components/quote-carousel'

// Custom web site components
import RemoteForm from './frontend/components/remote-form'
import RemoteSearchForm from './frontend/components/remote-search-form'
import FriendlyCaptcha from './frontend/components/friendly-captcha'
import FlatpickrInput from './frontend/components/flatpickr-input'
import TomSelectInput from './frontend/components/tom-select-input'

import { withTurbo } from './frontend/with-turbo'

customElements.define('check-to-toggle', withTurbo(CheckToToggle))
customElements.define('remote-form', withTurbo(RemoteForm))
customElements.define('sub-menu', withTurbo(Submenu))
customElements.define('menu-toggle', withTurbo(MenuToggle))
customElements.define('multi-toggler', withTurbo(MultiToggler))
customElements.define('remote-search-form', RemoteSearchForm)
customElements.define('wall-of-consent', withTurbo(WallOfConsent))
customElements.define('audio-player', withTurbo(AudioPlayer))
customElements.define('touch-detection', withTurbo(TouchDetection))
customElements.define('friendly-captcha', withTurbo(FriendlyCaptcha))
customElements.define('auto-submit-form', AutoSubmitForm)
customElements.define('quote-carousel', withTurbo(QuoteCarousel))
customElements.define('flatpickr-input', withTurbo(FlatpickrInput))
customElements.define('tom-select-input', withTurbo(TomSelectInput))
